import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card" }

import {ref, onMounted, reactive, watch} from "vue";
import ApiService from "@/core/services/ApiService";
import {getCSSVariableValue} from "@/assets/ts/_utils";
import {parseTime} from "@/utils";

// 表格载入延迟

export default /*#__PURE__*/_defineComponent({
  props: {
  data: {type: Array, required: true},  // 图形数据
},
  setup(__props) {

const props = __props

const loading = ref<boolean>(false);
const chart = ref<HTMLElement | null>(null);

const labelColor = getCSSVariableValue("--bs-" + "gray-800");
const strokeColor = getCSSVariableValue("--bs-" + "gray-300");
const baseColor = getCSSVariableValue("--bs-" + "primary");
const lightColor = getCSSVariableValue("--bs-light-" + "primary");
const series = ref<Array<any>>([]);
const options = reactive({
  chart: {
    type: 'area',
    fontFamily: "inherit",
  },
  plotOptions: {},
  legend: {
    show: false,
  },
  dataLabels: {
    enabled: false
  },
  stroke: {
    curve: "smooth",
    show: true,
    width: 3,
    colors: [baseColor],
  },
  fill: {
    type: "solid",
    opacity: 1,
  },
  xaxis: {
    type: 'category',
    categories: [],  //横坐标数组
    labels: {
      show: true,
    },
    tooltip: {
      enabled: false,
    },
  },
  yaxis: {
    min: 0,
    forceNiceScale: true,
    title: {
      text: '日志数量',
    }
  },
  colors: [lightColor],
  markers: {
    colors: [lightColor],
    strokeColor: [baseColor],
    strokeWidth: 3,
  },
})

onMounted(() => {
});

watch(props, (val) => {
  loadData();
});

// 数据载入
const loadData = () => {
  loading.value = true;
  let xfields = [];
  for (let d of props.data as []) {
    xfields.push(d['date']);
  }
  loading.value = false;
  options.xaxis.categories = [...xfields];
  (chart as any).value.updateOptions(options);

  let data = [];
  series.value = [];
  for (let d of props.data as []) {
    data.push(d['count']);
  }
  series.value.push({
    name: '日志数量',
    data: data,
  });
  (chart as any).value.updateSeries(series.value);
}

return (_ctx: any,_cache: any) => {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!loading.value)
      ? (_openBlock(), _createBlock(_component_apexchart, {
          key: 0,
          ref_key: "chart",
          ref: chart,
          type: "area",
          height: "200",
          options: _unref(options),
          series: series.value,
          class: "mixed-widget-7-chart card-rounded-bottom"
        }, null, 8, ["options", "series"]))
      : _createCommentVNode("", true)
  ]))
}
}

})